import { usePopupStore } from "@/stores/utils/popup";
export default {
    data() {
        return {
            formError: false,
            formSuccess: false,
            loading: false,
            hasChanged: false,
            isValid: null
        };
    },
    methods: {
        onInputChange() {
            this.hasChanged = true;

            if (this.formError) {
                this.formError = false;
            }

            if (this.formSuccess) {
                this.formSuccess = false;
            }
        },
        validateAllFields() {
            let allValid = true;
            let firstInvalidRef = null;
      
            Object.keys(this.$refs).forEach(ref => {
              if (this.$refs[ref] && typeof this.$refs[ref].triggerValidation === 'function') {
                const isValid = this.$refs[ref].triggerValidation();
                if (!isValid && !firstInvalidRef) {
                  firstInvalidRef = ref;
                  allValid = false;
                }
              }
            });
      
            this.isValid = allValid;
      
            if (!allValid && firstInvalidRef && !usePopupStore().popupType) {
              this.$nextTick(() => {
                const element = this.$refs[firstInvalidRef].$el;
                if (element) {
                  const elementOffset = element.getBoundingClientRect().top + window.scrollY - 128 - 42;
                  window.scrollTo({
                    top: elementOffset,
                    behavior: 'smooth'
                  });
                }
              });
            }
      
            return allValid;
        }
    }
};
  